`
<svg width="20" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  
</svg>
`;
import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const STROKE = color.text.feature;

const body: _SVGIcon.IconBody = (params) => {
	const stroke = params?.stroke ?? STROKE;
	return `
    <path d="M18 10L10.4375 20L7 15.4545" stroke="${stroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  `;
};

export default {
	W: 20,
	H: 32,
	body,
} as _SVGIcon.Icon;
